import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import VerifyModalStore from './store';
import TinyInput from '../../components/tiny-input';
import SmsCodeInput from '../../components/sms-code-input';
const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const VerifyModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.commonDemoModalRoot)}>
        <div className={styles.topImg} />
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.content}>
          <div className={styles.title}>手机号验证</div>
          <div className={styles.tips}>为确保简历信息为本人操作，请进行身份信息验证</div>

          <div className={cx(styles.phoneInput, store.phoneError && styles.error)}>
            <TinyInput placeholder="请输入手机号" store={store.phoneInputStore} />
            <div className={styles.errorTips}>请输入正确的手机号</div>
          </div>

          <div className={cx(styles.codeInput, store.codeError && styles.error)}>
            <TinyInput placeholder="验证码" store={store.smsInputStore} />
            <div className={styles.line} />
            <SmsCodeInput codeBtnClassName={styles.codeBtn} phone={store.phoneInputStore.value} buttonText={'获取验证码'} sendCode={store.onSendVCRequest} />
            <div className={styles.errorTips}>验证码错误，请重试</div>
          </div>
        </div>
        <div className={styles.centerBox}>
          <Link className={styles.btnCancel} onClick={store.onClickClose}>
            取消
          </Link>
          <Link className={styles.btnConfirm} onClick={store.onClickConfirm}>
            确认
          </Link>
        </div>
        <div className={styles.info}>说明：当前应聘记录查询当前只支持+86区号的手机号，如其他区号手机请静候邮箱通知</div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(VerifyModal, VerifyModalStore);
